module.exports = __webpack_public_path__ + "front/img/kv.49662e2d.jpg";